import React from "react";
import "../quizzes/QuizzCard.css";
import shareIcon from "../../assets/images/sharee.png";
import SearchQuizCountdown from './SearchQuizCountdown';
import SafeHtml from '../../components/SafeHtml';
const quizzTestCards = ({ items = [], onOpen, onShare }) => {
  const quizzTests = items.map((item, index) => ({
    ...item,
    number: String(index + 1).padStart(2, '0'),
    title: item.quiz_name || item.name || '',
    plan: item.free_paid === 'F' ? 'Free' : 'Prime',
    planClass: item.free_paid === 'F' ? 'free' : 'prime',
    date: item.start_date || '',
    duration: `${Number(item.duration || 0)} Minutes`,
    status: item.free_paid === 'F' ? item.solved_at || (item.quiz_live_type === 'L' ? 'Live' : 'Self-Paced') : 'Locked',
    questions: Number(item.total_questions || 0),
    attempts: Number(item.total_attempts || 0),
    language: item.available_languages || '',
    marks: Number(item.total_marks || 0),
    colorClass: ['green-card', 'blue-card', 'purple-card'][index % 3],
    progress: Number(item.total_questions) > 0 ? Math.round(Number(item.total_attempted_question || 0) * 100 / Number(item.total_questions)) : 0,
  }));
  return (
    <div className="quizz-test-wrapper">
      {quizzTests.map((test) => (
        <div className="quizz-test-card" key={test.number}>

          {/* Top Section */}
          <div className="quizz-test-top">

            <div className={`quizz-test-number ${test.colorClass}`}>
              {test.number}
            </div>

            <div className="quizz-test-info">
              <h3><button type="button" className="search-card-link" onClick={() => onOpen?.(test)}><SafeHtml as="span" inline value={test.title} /></button></h3>

              <div className="quizz-test-meta">
                <span className={`test-plan ${test.planClass}`}>
                  {test.plan}
                </span>

                <span className="meta-item">
                  <i className="bi bi-calendar3"></i>
                  {test.date}
                </span>

                <span className="meta-item">
                  <i className="bi bi-clock"></i>
                  {test.duration}
                </span>
              </div>
            </div>

            <button type="button" className="quiz-share-btn" onClick={() => onShare?.(test)} aria-label="Share quiz">
              <img src={shareIcon} alt=""/>
            </button>

          </div>

        {/* Progress */}
        <div className="quizz-progress-section">
         <div className="quizz-progress-line">
           <div className="quizz-progress-value"
                style={{
                    width: `${Math.min(Math.max(test.progress || 0, 0), 100)}%`,
                }}
                >
           </div>
         </div>
            <span className="quizz-progress-percent">
            {test.progress || 0}%
            </span>
        </div>

          {/* Status */}
          <div className="test-status">
            <span className={test.status === "Locked" ? "locked" : "recent"}>
              <SafeHtml as="span" inline value={test.status} />
            </span>
            {test.quiz_live_type === 'L' && <SearchQuizCountdown endDate={test.original_end_date || test.end_date} />}

            {test.coins && (
              <span className="coins-badge">
               <i className="fa-solid fa-coins"></i>
                {test.coins}
              </span>
            )}
          </div>

          {/* Bottom Stats */}
          <div className="quizz-test-stats">

            <div className="test-stat">
              <div className="stat-icon">
              <i className="bi bi-chat-text"></i>
              </div>

              <div>
                <strong>{test.questions}</strong>
                <small>Questions</small>
              </div>
            </div>

            <div className="test-stat">
              <div className="stat-icon">
                <i className="bi bi-pencil-square"></i>
              </div>

              <div>
                <strong>{test.attempts}</strong>
                <small>Attempts</small>
              </div>
            </div>

            <div className="test-stat">
              <div className="stat-icon">
                <i className="bi bi-translate"></i>
              </div>

              <div>
                <strong><SafeHtml as="span" inline value={test.language} /></strong>
                <small></small>
              </div>
            </div>

            <div className="test-stat">
              <div className="stat-icon">
              <i className="bi bi-patch-check"></i>
              </div>

              <div>
                <strong>{test.marks}</strong>
                <small>Marks</small>
              </div>
            </div>

          </div>
        </div>
      ))}
    </div>
  );
};

export default quizzTestCards;
